import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SummaryCardAction } from '@next/core-lib/components';

@Component({
  selector: 'app-flock-overview-panel',
  templateUrl: './flock-overview-panel.component.html',
  styleUrls: ['./flock-overview-panel.component.scss'],
  standalone: false,
})
export class FlockOverviewPanelComponent implements OnInit {
  @Input() title: string;
  @Input() isMobile: boolean;
  @Input() isEmpty: boolean;
  @Input() emptyMessage: string;
  @Input() showBottomBar: boolean;
  @Input() actionTitle: string;
  @Output() actionClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  actions: SummaryCardAction[] = [];

  ngOnInit(): void {
    if (this.actionTitle) {
      this.actions = [
        {
          id: 'overview-action',
          label: this.isMobile ? undefined : this.actionTitle,
          icon: 'arrow_forward',
          callback: () => {
            this.actionClicked.emit();
          },
        },
      ];
    }
  }
}
